// extracted by mini-css-extract-plugin
export default {"container":"TextArea-module--container--3eV1a","textarea":"TextArea-module--textarea--1lFRC"};